var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1593 12.2992L10.5762 18.6742C10.1212 19.1149 9.3854 19.1149 8.93523 18.6742L7.84126 17.6149C7.38625 17.1742 7.38625 16.4617 7.84126 16.0258L12.5076 11.507L7.84126 6.98828C7.38625 6.54766 7.38625 5.83516 7.84126 5.39922L8.93039 4.33047C9.3854 3.88984 10.1212 3.88984 10.5713 4.33047L17.1545 10.7055C17.6144 11.1461 17.6144 11.8586 17.1593 12.2992Z",
    fill: "#0C0589"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.7185f4dd1a10461d4f519d973247381b.svg";
export { ForwardRef as ReactComponent };